import * as React from 'react';
import { Button } from 'react-bootstrap';
import { copyToClipboard } from '../utl/EnvUtl';
import { FormDoc } from '../doc/FormDoc';

export interface DocToJSONProps
{
  doc: FormDoc;
}

export class DocToJSON extends React.Component<DocToJSONProps>
{
  public render()
  {
    return (
      <>
        <Button
          variant="outline-warning"
          onClick={() => copyToClipboard(this.docToJSON())}
        >
          DocToJSON
        </Button>
      </>
    );
  }

  private docToJSON(): string
  {
    const json = this.props.doc.toJSON();
    this.dropTechData(json);
    return JSON.stringify(json, undefined, 2);
  }

  private dropTechData(data: any): void
  {
    if (typeof data !== 'object')
    {
      return;
    }
    for (const key in data)
    {
      if (key === 'operationData'
        || key === 'id'
        || key === 'pk'
        || key === 'operationId')
      {
        delete data[key];
      }
      else
      {
        this.dropTechData(data[key]);
      }
    }
  }
}
